export default __webpack_public_path__ + "static/media/familia.558de27c.svg";